export interface ApiResponse<T> {
  status: IResponseStatus;
  message?: string;
  payload: T;
}

export interface RegistrationResponse {
  company: { _id: string; name: string };
  user: { _id: string; name: string; email: string };
  email: string;
  requiresEmailVerification: true;
  emailDeliveryStatus: EmailDeliveryStatus;
}

export enum EmailDeliveryStatus {
  SENT = 'sent',
  FAILED = 'failed',
}

export enum IResponseStatus {
  success = 'Success',
  error = 'Error',
}

export interface ApiError {
  code: string;
  message: string;
  status: number;
}

export enum ApiErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  EMAIL_CONFIRMATION_TOKEN_INVALID = 'EMAIL_CONFIRMATION_TOKEN_INVALID',
  EMAIL_CONFIRMATION_TOKEN_EXPIRED = 'EMAIL_CONFIRMATION_TOKEN_EXPIRED',
  EMAIL_CONFIRMATION_TOKEN_ALREADY_USED = 'EMAIL_CONFIRMATION_TOKEN_ALREADY_USED',
}
